import React, { useEffect, useState, useRef, useCallback } from 'react';

import { useParams, useNavigate, Link } from 'react-router-dom';

import Avatar from 'components/Avatar';
import Sidebar from 'components/Sidebar';

import ROUTES from 'utils/routes';

import { useUser } from 'utils/userContext';
import { backendFunction } from 'utils/backendApi';
import { MONTHLY_SUBSCRIPTION, getAccessNote, getSubscriptionStatusLabel, getSubscriptionTimingNote } from 'utils/subscription';


function PersonalDetailsIcon({ className }) {
    return <svg width="37" height="21" viewBox="0 0 37 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0215 14.7617C11.6065 14.7617 12.9491 14.8755 14.0488 15.1035C15.1484 15.3315 16.1355 15.6991 17.0098 16.207C17.7973 16.6789 18.3733 17.1511 18.7373 17.6231C19.1013 18.0951 19.2832 18.5839 19.2832 19.0879C19.2831 19.5456 19.1132 19.9387 18.7725 20.2666C18.4316 20.5946 18.0085 20.7588 17.5039 20.7588H2.56837C2.06186 20.7588 1.63376 20.6086 1.28517 20.3086C0.934831 20.0067 0.759847 19.6305 0.75978 19.1807C0.757854 18.6107 0.948786 18.0771 1.33205 17.5811C1.7153 17.0852 2.28227 16.6269 3.03322 16.207C3.90556 15.6991 4.89268 15.3315 5.99416 15.1035C7.09383 14.8755 8.43652 14.7617 10.0215 14.7617ZM35.0225 9.22364C35.4306 9.22373 35.7736 9.36644 36.0508 9.65235C36.3281 9.93833 36.4668 10.2948 36.4668 10.7207C36.4667 11.1464 36.3278 11.5031 36.0508 11.791C35.7735 12.0789 35.4296 12.2236 35.0195 12.2236H26.1328C25.7265 12.2236 25.3837 12.079 25.1045 11.791C24.8254 11.5031 24.6866 11.1474 24.6885 10.7236C24.6904 10.2996 24.8291 9.94328 25.1045 9.65528C25.3799 9.36735 25.7227 9.22367 26.1328 9.22364H35.0225ZM10.0215 0.913093C11.2387 0.915093 12.2657 1.34983 13.1016 2.21583C13.9371 3.08168 14.3544 4.14743 14.3545 5.41309C14.3545 6.67896 13.9373 7.74631 13.1016 8.61426C12.2677 9.48026 11.2406 9.91309 10.0215 9.91309C8.80441 9.91906 7.77821 9.48618 6.9424 8.61426C6.10655 7.74226 5.68849 6.67509 5.68849 5.41309C5.68856 4.15126 6.10665 3.08574 6.9424 2.21583C7.77822 1.34586 8.80437 0.911123 10.0215 0.913093ZM35.0225 0.913093C35.4306 0.915185 35.7736 1.0598 36.0508 1.34571C36.3279 1.63159 36.4667 1.98738 36.4668 2.41309C36.4668 2.83903 36.3281 3.19547 36.0508 3.48145C35.7735 3.76937 35.4296 3.91301 35.0195 3.91309H26.1328C25.7265 3.91306 25.3837 3.77035 25.1045 3.48438C24.8253 3.19839 24.6866 2.84201 24.6885 2.41602C24.6905 1.99027 24.8293 1.63359 25.1045 1.34571C25.3799 1.05774 25.7227 0.913124 26.1328 0.913093H35.0225Z" fill="var(--text)" />
    </svg>
}

function SavedCheckIcon({ className }) {
    return <svg className={className} width="13" height="10" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 0L4.2 6.8L1.4 4L0 5.4L4.2 9.6L12.4 1.4L11 0Z" fill="gray" />
    </svg>
}

function GoalIcon({ className }) {
    return <svg className={className} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8778 10.8784C10.446 11.308 10.2022 11.8914 10.2 12.5005C10.2 13.1105 10.4423 13.6955 10.8736 14.1269C11.3049 14.5582 11.89 14.8005 12.5 14.8005C13.1091 14.7983 13.6925 14.5545 14.1221 14.1226" stroke="var(--text)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5003 5.6001C11.1357 5.6001 9.80161 6.00477 8.66691 6.76296C7.53221 7.52114 6.64782 8.59877 6.12558 9.85958C5.60333 11.1204 5.46669 12.5078 5.73293 13.8462C5.99916 15.1847 6.65633 16.4141 7.62131 17.3791C8.58629 18.3441 9.81575 19.0013 11.1542 19.2675C12.4927 19.5338 13.88 19.3971 15.1409 18.8749C16.4017 18.3526 17.4793 17.4682 18.2375 16.3335C18.9957 15.1988 19.4003 13.8648 19.4003 12.5001" stroke="var(--text)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 1C10.2255 1 8.00211 1.67446 6.11095 2.9381C4.21978 4.20173 2.7458 5.99779 1.87539 8.09914C1.00498 10.2005 0.777244 12.5128 1.22097 14.7435C1.6647 16.9743 2.75997 19.0234 4.36828 20.6317C5.97658 22.24 8.02568 23.3353 10.2565 23.779C12.4872 24.2228 14.7995 23.995 16.9009 23.1246C19.0022 22.2542 20.7983 20.7802 22.0619 18.8891C23.3255 16.9979 24 14.7745 24 12.5M16.7671 8.2341L13.65 11.35" stroke="var(--text)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M23.3222 5.04772L19.4001 5.59972L19.9521 1.67761C19.9561 1.63206 19.9465 1.58633 19.9244 1.54627C19.9024 1.50621 19.8689 1.47364 19.8282 1.45272C19.7875 1.4318 19.7415 1.42348 19.6961 1.42882C19.6507 1.43417 19.6079 1.45293 19.5732 1.48272L16.973 4.06961C16.7059 4.33861 16.5095 4.66946 16.4011 5.03271C16.2928 5.39596 16.2759 5.78036 16.352 6.15172L16.766 8.23382L18.8481 8.64661C19.2194 8.72269 19.6038 8.70581 19.9671 8.59747C20.3303 8.48913 20.6612 8.29268 20.9302 8.02561L23.5159 5.42661C23.5458 5.39183 23.5646 5.34891 23.5699 5.30335C23.5752 5.2578 23.5668 5.2117 23.5457 5.17097C23.5246 5.13024 23.4919 5.09674 23.4516 5.07478C23.4113 5.05282 23.3654 5.04339 23.3198 5.04772" stroke="var(--text)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}

function SubtractGoalIcon({ className, color }) {
    return <svg className={className} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0ZM9 12C8.44771 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14H17L17.1025 13.9951C17.6067 13.9438 18 13.5177 18 13C18 12.4823 17.6067 12.0562 17.1025 12.0049L17 12H9Z" fill={color} />
    </svg>
}

function AddGoalIcon({ className, color }) {
    return <svg className={className} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0ZM13 8C12.4477 8 12 8.44772 12 9V12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14H12V17C12 17.5523 12.4477 18 13 18C13.5523 18 14 17.5523 14 17V14H17L17.1025 13.9951C17.6067 13.9438 18 13.5177 18 13C18 12.4823 17.6067 12.0562 17.1025 12.0049L17 12H14V9C14 8.44771 13.5523 8 13 8Z" fill={color} />
    </svg>
}



function Settings() {

    const [saved, setSaved] = useState(true);

    const { user, loading, updateUserData, logout, hasPaidAccess, isBillingExempt, subscriptionStatus } = useUser();

    const [deleteModal, setDeleteModal] = useState(false);
    const [resetModal, setResetModal] = useState(false);

    const [confirmText, setConfirmText] = useState("");
    const [resetConfirmText, setResetConfirmText] = useState("");

    const { tab } = useParams();
    const navigate = useNavigate();
    const accessNote = getAccessNote(user);
    const subscriptionTimingNote = getSubscriptionTimingNote(user);

    useEffect(() => {
        if (!tab || (tab !== "basic" && tab !== "notifications" && tab !== "subscription")) {
            // Redirect to the default tab if no tab is specified
            return navigate(`${ROUTES.SETTINGS}/basic`);
        }
    }, [tab, navigate]);

    const handleTabChange = (newTab) => {
        navigate(`${ROUTES.SETTINGS}/${newTab}`);
    };





    const [usernameValue, setUsernameValue] = useState("");
    useEffect(() => {
        if (!loading && user) {
            setUsernameValue(user.username);
        }
    }, [loading, user]);

    useEffect(() => {
        if (loading || !user) return;

        const cleaned = usernameValue.trim().replace(/[^\w- ]/g, '');

        // Skip everything if it matches
        if (cleaned === user.username) {
            setSaved(true);
            return;
        }

        setSaved(false);
        const timeout = setTimeout(() => {
            console.log("Updating username to:", cleaned);
            updateUserData({ username: cleaned });
            setSaved(true);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [usernameValue, loading, user?.username]);

    const GOAL_LIMITS = {
        time: { min: 5, max: 60 },
        lesson: { min: 1, max: 15 },
    };
    const [lastConfirmedGoals, setLastConfirmedGoals] = useState({ time: 0, lesson: 0 });
    const [pendingGoals, setPendingGoals] = useState({ time: 0, lesson: 0 });
    const updateTimeout = useRef(null);

    const [forceLightMode, setForceLightMode] = useState(false);
    const [billingLoading, setBillingLoading] = useState(false);
    const [billingMessage, setBillingMessage] = useState("");
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteError, setDeleteError] = useState("");

    useEffect(() => {
        const stored = localStorage.getItem("kodeo.forceLightMode");
        setForceLightMode(stored === "true");
    }, []);

    const handleGoalChange = (type, change) => {
        if (!user) return;


        setPendingGoals(prev => {
            const newPending = { ...prev, [type]: prev[type] + change };

            const proposedGoal = user[`${type}Goal`] + newPending[type];
            const { min, max } = GOAL_LIMITS[type];

            if (proposedGoal < min || proposedGoal > max) return prev; // clamp

            setSaved(false);

            if (updateTimeout.current) clearTimeout(updateTimeout.current);

            updateTimeout.current = setTimeout(() => {
                const updatedGoals = {
                    timeGoal: user.timeGoal + newPending.time,
                    lessonGoal: user.lessonGoal + newPending.lesson,
                };
                updateUserData(updatedGoals);
                setLastConfirmedGoals({
                    time: updatedGoals.timeGoal,
                    lesson: updatedGoals.lessonGoal,
                });
                setPendingGoals({ time: 0, lesson: 0 });
                setSaved(true);
            }, 1000);

            return newPending;
        });
    };


    function handleForceLightModeChange(e) {
        const forceLight = e.target.checked;
        setForceLightMode(forceLight);
        localStorage.setItem("kodeo.forceLightMode", forceLight ? "true" : "false");
        window.location.reload(); // Reload to apply the new mode
    }

    async function openBillingPortal() {
        setBillingLoading(true);
        setBillingMessage("");

        const { data, error } = await backendFunction('create-customer-portal-session', {
            method: 'POST',
            withAuth: true,
        });

        if (error || !data?.url) {
            setBillingMessage(error || "Unable to open Stripe billing right now.");
            setBillingLoading(false);
            return;
        }

        window.location.assign(data.url);
    }

    async function handleDeleteAccount() {
        setDeleteLoading(true);
        setDeleteError("");

        const { error } = await backendFunction('delete-account', {
            method: 'POST',
            withAuth: true,
        });

        if (error) {
            setDeleteError(error);
            setDeleteLoading(false);
            return;
        }

        for (let key in localStorage) {
            if (key.startsWith("kodeo.concept-")) {
                localStorage.removeItem(key);
            }
        }

        localStorage.removeItem('kodeo.guestUser');
        setDeleteModal(false);
        setConfirmText("");
        await logout({ scope: 'local' });
        navigate(ROUTES.LANDING, { replace: true });
    }

    const shownTime = loading
        ? ".."
        : (pendingGoals.time !== 0
            ? user.timeGoal + pendingGoals.time
            : lastConfirmedGoals.timeGoal || user.timeGoal);

    const shownLesson = loading
        ? ".."
        : (pendingGoals.lesson !== 0
            ? user.lessonGoal + pendingGoals.lesson
            : lastConfirmedGoals.lessonGoal || user.lessonGoal);

    return (
        <div className="text-text flex flex-row items-center h-screen gap-4 bg-background p-4 lg:p-8" >
            <Sidebar></Sidebar>
            <div className='w-full flex flex-col items-center h-full px-2 lg:px-0 xl:px-12 overflow-y-auto gap-4 flex-shrink '>
                <div className="h-[3.7rem] min-h-[3.7rem] select-none flex justify-between items-center  w-full max-w-[900px]">
                    <div className="h-full flex flex-col justify-end">
                        {/* <h1 className="text-gray-500 text-sm md:text-base drop-shadow-lg max-w-2xl ">
                            { }
                        </h1> */}
                        <h1 className=" text-text text-3xl md:text-[2.25rem] leading-[1] font-bold drop-shadow-lg max-w-2xl ">
                            Settings
                        </h1>
                    </div>
                    {!user?.isGuest && (<Avatar size={"xs"} showRings={false} dropdown={true} />)}

                </div>

                {user?.isGuest ? (
                    <div className='w-full max-w-[900px]'>
                        <div className='flex flex-col w-full bg-background-pop h-full rounded-3xl p-8 items-center text-xl gap-8 text-center'>
                            <span>You are in guest mode. Please make an account to save your progress, customize your experience, and access more features.</span>
                            <Link to={ROUTES.SIGNUP} className="bg-background-light text-white font-bold px-4 py-2 rounded-2xl shadow-md hover:bg-background transition-all duration-500 text-lg border-2 border-primary">CREATE AN ACCOUNT</Link>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className='select-none flex justify-between  w-full max-w-[900px] border-b-2 border-border items-center'>
                            <div className='flex gap-4 w-full px-7'>
                                <button className='font-bold  border-text p-2 px-3' style={{ color: tab === "basic" ? 'var(--text)' : 'var(--text-light)', borderBottom: tab === "basic" ? '2px solid var(--text)' : 'none' }} onClick={() => handleTabChange("basic")}>Basic info</button>
                                <button className='font-bold border-text p-2 px-3' style={{ color: tab === "subscription" ? 'var(--text)' : 'var(--text-light)', borderBottom: tab === "subscription" ? '2px solid var(--text)' : 'none' }} onClick={() => handleTabChange("subscription")}>Subscription</button>
                            </div>
                            <span className='flex items-end h-full gap-1 text-sm font-bold pb-1 px-1' style={{ color: "gray", opacity: saved ? 1 : 0.3 }}><SavedCheckIcon className={"mb-[0.3rem]"} />{saved ? "Saved" : "Saving..."}</span>
                        </div>

                        <div className='flex flex-col w-full flex-grow overflow-y-auto max-w-[900px] mt-5 text-text px-8'>
                            {tab === "basic" && <div className='flex flex-col gap-4'>
                                <div className='flex gap-4 items-center'>
                                    <PersonalDetailsIcon />
                                    <div className='flex flex-col'>
                                        <h1 className='font-bold leading-[1]'>Personal details</h1>
                                        <span className='text-sm font-medium text-text-light'>The information for this account</span>
                                    </div>
                                </div>
                                <div className='flex flex-col'>
                                    <h1 className='font-bold text-lg'>Display name</h1>
                                    <input type="text" className='w-full bg-transparent outline-none text-text text-base font-bold border-2 border-border focus:border-border-light rounded-xl p-2 px-3 mt-2 max-w-80' placeholder='Enter your display name' value={usernameValue} onInput={(e) => {
                                        const input = e.target;
                                        const raw = input.value;
                                        const trimmed = raw.trimStart().replace(/[^\w- ]/g, '').slice(0, 30);
                                        if (trimmed !== usernameValue) {
                                            setUsernameValue(trimmed);
                                        }
                                    }} />
                                </div>
                                <div className='flex flex-col'>
                                    <h1 className='font-bold text-lg'>Email</h1>
                                    <input type="text" disabled={true} className=' w-full bg-transparent outline-none text-text text-base font-bold border-2 border-border focus:border-border-light rounded-xl p-2 px-3 mt-2 max-w-80 cursor-text opacity-75' value={!loading && user ? user.email : ".."} />
                                </div>

                                <div className='flex gap-4 items-center mt-10'>
                                    <GoalIcon />
                                    <div className='flex flex-col'>
                                        <h1 className='font-bold leading-[1]'>Goals</h1>
                                        <span className='text-sm font-medium text-text-light'>Your daily learning goals</span>
                                    </div>
                                </div>
                                <div className='flex flex-row gap-4 h-[7.5rem]'>
                                    <div className='h-full flex flex-col items-center justify-center gap-2 p-3 border-border border-[3px] rounded-xl w-52'>
                                        <span className='font-bold text-center text-sm text-primary'>TIME GOAL</span>
                                        <div className='flex items-center gap-5 justify-between'>
                                            <button className='rounded-full' onClick={() => handleGoalChange("time", -1)}><SubtractGoalIcon className={"w-8 h-8"} color={"var(--primary"} /></button>
                                            <span className='text-2xl font-bold'>{!loading && user ? shownTime : ".."}</span>
                                            <button className='rounded-full' onClick={() => handleGoalChange("time", 1)}><AddGoalIcon className={"w-8 h-8"} color={"var(--primary"} /></button>
                                        </div>
                                        <span className='font-bold text-center text-sm text-primary'>MINUTES</span>
                                    </div>
                                    <div className='h-full flex flex-col items-center justify-center gap-2 p-3 border-border border-[3px] rounded-xl w-52'>
                                        <span className='font-bold text-center text-sm text-accent'>LESSON GOAL</span>
                                        <div className='flex items-center gap-5 justify-between'>
                                            <button className='rounded-full' onClick={() => handleGoalChange("lesson", -1)}><SubtractGoalIcon className={"w-8 h-8"} color={"var(--accent"} /></button>
                                            <span className='text-2xl font-bold'>{!loading && user ? shownLesson : ".."}</span>
                                            <button className='rounded-full' onClick={() => handleGoalChange("lesson", 1)}><AddGoalIcon className={"w-8 h-8"} color={"var(--accent"} /></button>
                                        </div>
                                        <span className='font-bold text-center text-sm text-accent'>LESSONS</span>
                                    </div>
                                </div>
                                <div className='flex flex-col mt-4 gap-2 w-fit'>
                                    <h1 className='font-bold text-lg'>Accessibility</h1>
                                    <div className='font-bold text-text-light flex gap-2 items-center pl-2'>
                                        High Contrast:
                                        <label>
                                            <input type="checkbox" name="forceLightMode" id="forceLightMode" className='peer opacity-50 hidden' checked={forceLightMode} onChange={handleForceLightModeChange} />
                                            <div className='w-6 h-6 bg-transparent border-accent border-2 peer-checked:bg-accent flex items-center justify-center rounded-lg cursor-pointer text-transparent peer-checked:text-white transition-colors duration-200'>
                                                <svg className='w-5 h-5 mt-1 fill-[currentColor]' fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M4 8l2 2 6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <span className='text-xs font-normal pt-1' style={{ opacity: forceLightMode ? 1 : 0 }}>(not recommended)</span>
                                    </div>
                                </div>

                                <div className='flex flex-col mt-4 gap-2'>
                                    <h1 className='font-bold text-lg'>Account</h1>
                                    <div className='flex gap-3'>
                                        <button
                                            className='text-base font-bold bg-warning rounded-xl p-2 px-4 w-fit'
                                            onClick={() => {
                                                setDeleteModal(true);
                                                setConfirmText("");
                                                setDeleteError("");
                                            }}
                                        >DELETE ACCOUNT</button>
                                        <button
                                            className='text-base font-bold border-2 border-warning rounded-xl p-2 px-4 w-fit'
                                            onClick={() => {
                                                setResetModal(true);
                                                setResetConfirmText("");
                                            }}
                                        >RESET PROGRESS</button>
                                    </div>
                                </div>
                            </div>}
                            {tab === "notifications" && <div className='flex flex-col gap-4'>

                            </div>}
                            {tab === "subscription" && <div className='flex flex-col gap-5'>
                                <div className='rounded-3xl border-2 border-primary p-6 bg-[color:color-mix(in_srgb,var(--primary)_10%,transparent)]'>
                                    <p className='text-text-light font-bold uppercase tracking-[0.24em] text-sm'>Membership</p>
                                    <h1 className='text-3xl font-extrabold mt-2'>{MONTHLY_SUBSCRIPTION.name}</h1>
                                    <p className='text-text-light mt-3 max-w-2xl'>{MONTHLY_SUBSCRIPTION.tagline}</p>
                                    <div className='text-5xl font-black mt-6'>{MONTHLY_SUBSCRIPTION.priceDisplay}</div>
                                </div>

                                <div className='rounded-3xl border-2 border-border p-6 bg-background-pop'>
                                    <div className='flex flex-col gap-3'>
                                        <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-3'>
                                            <div>
                                                <h2 className='text-2xl font-bold'>Current access</h2>
                                                <p className='text-text-light mt-1'>{getSubscriptionStatusLabel(user)}</p>
                                            </div>
                                            <div className='text-left md:text-right'>
                                                <div className='text-sm text-text-light'>Status</div>
                                                <div className='font-bold'>
                                                    {hasPaidAccess ? 'Full access enabled' : 'Subscription required'}
                                                </div>
                                            </div>
                                        </div>

                                        {accessNote && (
                                            <p className='text-sm text-text-light'>
                                                Access note: {accessNote}
                                            </p>
                                        )}

                                        {subscriptionTimingNote && (
                                            <p className='text-sm text-text-light'>
                                                {subscriptionTimingNote}
                                            </p>
                                        )}

                                        {subscriptionStatus && !isBillingExempt && (
                                            <p className='text-sm text-text-light'>
                                                Stripe status: <span className='font-bold text-text'>{subscriptionStatus}</span>
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className='flex flex-wrap gap-3'>
                                    {!hasPaidAccess && (
                                        <Link to={ROUTES.SUBSCRIPTION} className='text-base font-bold bg-primary text-background rounded-xl p-3 px-5 w-fit border-2 border-primary'>
                                            Start monthly membership
                                        </Link>
                                    )}
                                    {Boolean(user?.stripe_customer_id) && (
                                        <button
                                            disabled={billingLoading}
                                            onClick={openBillingPortal}
                                            className='text-base font-bold border-2 border-primary rounded-xl p-3 px-5 w-fit disabled:opacity-60'
                                        >
                                            {billingLoading ? 'Opening billing...' : 'Manage billing'}
                                        </button>
                                    )}
                                </div>

                                {billingMessage && <p className='text-sm text-warning'>{billingMessage}</p>}
                            </div>}
                        </div></>)}
            </div>

            <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center transition-opacity duration-300 ease z-50'
                style={{ opacity: deleteModal ? 1 : 0, pointerEvents: deleteModal ? "auto" : "none" }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setDeleteModal(false);
                    }
                }}
            >
                <div className='bg-background rounded-lg p-6 max-w-sm w-full text-text'>
                    <h2 className='text-lg font-bold mb-4'>Confirm Deletion</h2>
                    <p className='mb-3'>Are you sure you want to delete your account? This action cannot be undone.</p>
                    <p className='mb-6 text-sm text-text-light'>Your Kodeo account will be removed permanently and any active Stripe subscription will be canceled immediately.</p>
                    <p className='mb-1'>Please type "DELETE FOREVER" to confirm.</p>
                    <input disabled={deleteLoading} onChange={(e) => setConfirmText(e.target.value)} value={confirmText} type="text" className='border-2 border-border bg-transparent rounded-xl px-4 py-2 mb-4 disabled:opacity-60' />
                    {deleteError && <p className='mb-4 text-sm text-warning'>{deleteError}</p>}
                    <div className='flex justify-end font-bold'>
                        <button disabled={confirmText !== "DELETE FOREVER" || deleteLoading} className='bg-red-500 disabled:opacity-40 rounded-xl px-6 py-2 mr-2' onClick={handleDeleteAccount}>{deleteLoading ? "DELETING..." : "DELETE"}</button>
                        <button disabled={deleteLoading} className='border-2 border-border text-text rounded-xl px-6 py-2 disabled:opacity-60' onClick={() => setDeleteModal(false)}>CANCEL</button>
                    </div>
                </div>
            </div>
            <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center transition-opacity duration-300 ease z-50'
                style={{ opacity: resetModal ? 1 : 0, pointerEvents: resetModal ? "auto" : "none" }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setResetModal(false);
                    }
                }}
            >
                <div className='bg-background rounded-lg p-6 max-w-sm w-full text-text'>
                    <h2 className='text-lg font-bold mb-4'>Confirm Reset</h2>
                    <p className='mb-6'>Are you sure you want to reset your progress? This action cannot be undone. </p>
                    <p className='mb-1'>Please type "RESET PROGRESS" to confirm.</p>
                    <input onChange={(e) => setResetConfirmText(e.target.value)} value={resetConfirmText} type="text" className='border-2 border-border bg-transparent rounded-xl px-4 py-2 mb-4' />
                    <div className='flex justify-end font-bold'>
                        <button disabled={resetConfirmText !== "RESET PROGRESS" && (!loading && !user.is_admin)} className='bg-red-500 disabled:opacity-40 rounded-xl px-6 py-2 mr-2' onClick={() => {
                            setResetModal(false);
                            updateUserData({ currentUnit: 1, currentConcept: 1, currentConceptProgress: 1, timeGoal: 30, lessonGoal: 7, awards: [] });
                            for (let key in localStorage) {
                                if (key.startsWith("kodeo.concept-")) {
                                    localStorage.removeItem(key);
                                }
                            }
                        }}>RESET</button>
                        <button className='border-2 border-border text-text rounded-xl px-6 py-2' onClick={() => setResetModal(false)}>CANCEL</button>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default Settings;
